import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";

import EditGarageLayer from "../../components/garages/EditGarageLayer";

const EditGaragePage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb
          routePath="/all-garages"
          routeName="All Garages"
          title="Edit Garage"
        />

        {/* AddUserLayer */}
        <EditGarageLayer />
      </MasterLayout>
    </>
  );
};

export default EditGaragePage;
